import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const getDomainsByType = (domainType) => {
  return base.get({
    url: API_PARAM.DOMAINS,
    params: { type: domainType },
  });
};

export const getDomainById = (id) => {
  return base.get({
    url: `${API_PARAM.DOMAINS}/${id}`,
  });
};

export const getSkillPathsByDomainId = (id) => {
  return base.get({
    url: API_PARAM.DOMAIN_SKILL_PATHS,
    params: { id },
  });
};

export const getNextCourse = (domainId) => {
  return base.get({
    url: API_PARAM.NEXT_DOMAIN_COURSE,
    params: { id: domainId },
  });
};

export const enrollUserInDomain = (domainId) => {
  return base.post({
    url: API_PARAM.DOMAIN_ENROLLMENT,
    params: { id: domainId },
    nonceHeader: true,
  });
};

export const getJobCourses = (jobId) => {
  return base.get({
    url: API_PARAM.DOMAIN_COURSES,
    params: { id: jobId },
  });
};

export const saveUserRating = (data) => {
  return base.post({
    url: API_PARAM.USER_RATING,
    data: data,
    nonceHeader: true,
  });
};

export const getRelatedJobs = (jobId) => {
  return base.get({
    url: API_PARAM.RELATED_JOBS,
    params: { id: jobId },
  });
};

export const getJobsUsingSkill = (jobId) => {
  return base.get({
    url: API_PARAM.JOBS_USING_SKILL,
    params: { id: jobId },
  });
};

export const getUserDomainRecommendedSkillPaths = (domainId) => {
  return base.get({
    url: API_PARAM.USERS_DOMAIN_RECOMMENDED_SKILL_PATHS,
    params: { id: domainId },
  });
};